/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanySettings } from './CompanySettings';
import {
    CompanySettingsFromJSON,
    CompanySettingsFromJSONTyped,
    CompanySettingsToJSON,
    CompanySettingsToJSONTyped,
} from './CompanySettings';

/**
 * Serializer for listing companies (admin only)
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    name: string;
    /**
     * 
     * @type {CompanySettings}
     * @memberof Company
     */
    settings: CompanySettings;
    /**
     * 
     * @type {Array<number>}
     * @memberof Company
     */
    defaultForms?: Array<number>;
}

/**
 * Check if a given object implements the Company interface.
 */
export function instanceOfCompany(value: object): value is Company {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('settings' in value) || value['settings'] === undefined) return false;
    return true;
}

export function CompanyFromJSON(json: any): Company {
    return CompanyFromJSONTyped(json, false);
}

export function CompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Company {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'settings': CompanySettingsFromJSON(json['settings']),
        'defaultForms': json['default_forms'] == null ? undefined : json['default_forms'],
    };
}

export function CompanyToJSON(json: any): Company {
    return CompanyToJSONTyped(json, false);
}

export function CompanyToJSONTyped(value?: Omit<Company, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'settings': CompanySettingsToJSON(value['settings']),
        'default_forms': value['defaultForms'],
    };
}

